const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTerms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "z89alrr8qa"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 80",
    transform: "translate(-.681)",
    style: {
      fill: "#9c9c9c"
    },
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 303",
    transform: "translate(.681)",
    style: {
      clipPath: "url(#z89alrr8qa)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 302"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4266",
    d: "m10.475 14.505-1.21-1.284a.849.849 0 0 0-1.251 0 .978.978 0 0 0 0 1.326l1.836 1.947a.849.849 0 0 0 1.251 0l4.4-4.662a.978.978 0 0 0 0-1.326.849.849 0 0 0-1.251 0z",
    transform: "translate(-.44)",
    style: {
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4267",
    d: "M19.011 1.781h-4.955V.938A.912.912 0 0 0 13.171 0h-3.36a.912.912 0 0 0-.884.938v.844H3.978a.912.912 0 0 0-.884.938v20.343a.912.912 0 0 0 .884.937h15.033a.912.912 0 0 0 .884-.937V2.719a.912.912 0 0 0-.884-.938zm-8.311.094h1.592v1.688H10.7zm7.431 20.25H4.862V3.656h4.065V4.5a.912.912 0 0 0 .884.938h3.36a.912.912 0 0 0 .884-.937v-.845h4.071z",
    transform: "translate(-.176)",
    style: {
      fill: "#9c9c9c"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerms);
export default __webpack_public_path__ + "static/media/terms.0c1b534ebd4ad62f2dfc09d0b30da731.svg";
export { ForwardRef as ReactComponent };